<template>
  <component :is="editable ? Host : Guest"></component>
</template>

<script setup lang="ts">
import Host from './Host.vue'
import Guest from './Guest.vue'
import { usePersonalPageEditable } from './hooks'

const userInfo = useUserInfo()
const routeHistory = useRouteHistory()

provideResourceLocation({
  source: SOURCE.PERSONAL_PAGE,
})

watch(
  () => userInfo.value?.organization_id,
  (v) => {
    if (v) {
      location.href = `/personal-page/${v}.html`
    }
  }
)

onMounted(() => {
  trackEvent(TRACK_EVENT.PAGE_PERSONAL_PAGE, {
    referrer: routeHistory.value?.[routeHistory.value.length - 1]?.name,
    // user_id: userInfo.value?.user_id,
    user_nickname: userInfo.value?.username,
  })
})

const editable = usePersonalPageEditable()
</script>
